<template>
  <div class="ElementScaler" :style="{}" :class="{}">

    <div v-for="(el,i) in elements" class="slot" :style="{'transform': 'scale('+calcScale()+')'}">
      <slot :name="el">
      </slot>
    </div>

  </div>
</template>

<script>

//import ScrollVideo from '@assets/components/ScrollVideo.vue'
import { eventBus } from '@/utils'

export default {
  name: 'ElementScaler',
  props: {
    elements: Array,
    elref: {default: null},
    delay: {type: Number, default: 0},
  },
  data: function () {
    return {
      scroll: Number
    }
  },
  computed: {
  },
  methods: {
    setCallbacks: function () {
    },
    onScroll: function (scrollTop) {
      this.scroll = this.elref.$el.getBoundingClientRect().top
      //this.scroll = this.$el.getBoundingClientRect().top
    },
    calcScale: function(){
      return Math.max(0,Math.min(1,-(this.scroll + this.delay * window.innerHeight/100)/100))
    }
  },
  created: function () {
    eventBus.$on('scroll',(e) => {
      this.onScroll(e.srcElement.scrollTop)
    });
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ElementScaler{
  position: relative;
  height: 100%;
}

.slot{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

</style>
